import { Facebook, Twitter, Linkedin, Share2 } from "lucide-react";

interface SocialShareButtonsProps {
  url?: string;
  title?: string;
  description?: string;
  className?: string;
}

const SocialShareButtons = ({ 
  url = "https://mysabbat.dk",
  title = "MySabbat – Guides til sabbatår, rejse, job og højskole",
  description = "Planlægger du sabbatår? Få gratis guides til rejse, job, højskole og økonomi.",
  className = ""
}: SocialShareButtonsProps) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedDescription = encodeURIComponent(description);

  const shareLinks = [
    {
      name: "Facebook",
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      color: "hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2]"
    },
    {
      name: "Twitter",
      icon: Twitter,
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      color: "hover:bg-[#1DA1F2] hover:text-white hover:border-[#1DA1F2]"
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: "hover:bg-[#0A66C2] hover:text-white hover:border-[#0A66C2]"
    }
  ];

  const handleShare = (href: string) => {
    window.open(href, "_blank", "width=600,height=400,noopener,noreferrer");
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
        <Share2 className="w-4 h-4" />
        Del MySabbat
      </span>
      <div className="flex gap-2">
        {shareLinks.map((link) => (
          <button
            key={link.name}
            onClick={() => handleShare(link.href)}
            aria-label={`Del på ${link.name}`}
            className={`w-10 h-10 rounded-full border border-border bg-card flex items-center justify-center text-muted-foreground transition-all duration-200 ${link.color}`}
          >
            <link.icon className="w-4 h-4" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default SocialShareButtons;
